module.exports = __webpack_public_path__ + "static/media/Soak.baeb6c58.svg";